import React from 'react';
import { Trans } from 'react-i18next';
import MessageMarkdown from '../../../../../../Base/Utils/MessageMarkdown/MessageMarkdown';
const WhatsappPostback = ({ message, text }) => {
    return (React.createElement("div", null,
        text && React.createElement(MessageMarkdown, { text: text }),
        !text && (message.flow_reply || message.flow_cta) && React.createElement(Trans, { i18nKey: "whatsappFlowMessage" })));
};
export default WhatsappPostback;
